module.exports = __webpack_public_path__ + "img/chinese_1.a54df597.png";